import { CONSTANTS } from "../../constants/Constants";
import Button from "../Buttons";
import HeroImage from "../../assets/images/hero_image.png"
import RocketIcon from "../../assets/icons/rocket_icon.svg"
interface HeroSectionProps {
  journeyHandler: () => void
}
const Hero = ({ journeyHandler }: HeroSectionProps) => {
  return (
    <div
      className="bg-cover bg-center pt-5 relative mb-0 lg:mb-[60px] w-100"
    >
      <div className="lg:mt-10 layout-container justify-center flex flex-col lg:flex-row lg:!px-40">
        <div className="lg:mt-4 mb-[15px] lg:mb-0">
          <p className="mb-[10px]">Maximum Impact, Minimum Effort: Present Tech Talent Like Never Before</p>
          <h1 className="lg:text-[56px] text-[36px] leading-[45px] lg:leading-[60px] font-semibold m-0 p-0">
            {CONSTANTS.PRESENT_CANDIDATES_TXT}
          </h1>

          <div className="flex flex-col leading-6 mt-[15px] mb-[20px] lg:my-[35px]">
            With TalentHub, you can present tech candidates through dynamic, fully personalized profiles. Featuring detailed skill summaries and pre-assessed video introductions, your clients can quickly see which candidates are the right fit for their team — both in terms of skillset and personality.
          </div>
          <div className="lg:flex gap-3 lg:w-[80%]">
            <div onClick={journeyHandler} className="cursor-pointer flex !bg-[#23FF9C] rounded-full overflow-hidden px-5 mb-[15px] lg:mb-0 justify-center">
              <Button
                btn_label="Start your journey"
                other_classes="!bg-transparent !text-[#232323] !w-fit !text-[14px]"
                on_click_handler={()=>{}}
              />
              <img src={RocketIcon} alt="icon" className="ml-2" />
            </div>
            <Button
              type="secondary"
              btn_label="Talk with our sales person"
              on_click_handler={() => { }}
              other_classes="!bg-[#F5F5F5] !text-[#000000] lg:!w-[50%] !text-[14px]"
            />
          </div>
        </div>
        <img src={HeroImage} alt="hero_image" className="m-auto w-auto" />
      </div>
    </div>
  );
};

export default Hero;
